import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import anavu_logo from "../images/iiit_logo_black.png";
import { getToken, getProfile } from "../Storage/Storage"; // Import function to check authentication and profile
import { userProfile } from "../Services/AllServices"; // Import function to get user details, including download count

const Navbar = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Track if user is authenticated
  const [userRole, setUserRole] = useState(null); // Track the user's role
  const [downloadCount, setDownloadCount] = useState(null); // Track download count for teacher
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  useEffect(() => {
    // Check if the user is authenticated and fetch their profile
    const checkAuth = async () => {
      const token = await getToken();
      if (token) {
        const profile = await getProfile(); // Fetch the user role
        setIsAuthenticated(true); // User is authenticated
        setUserRole(profile); // Set the user's role (Student, Teacher, Moderator)

        if (profile === "Teacher") {
          // const userData = await userProfile(); // Fetch the user's full profile including download count
          await userProfile((response) => {
            if (response && response.status === "success") {
              console.log("navbar", response);
              setDownloadCount(response.data.downloadCount);
              // console.log("download count:", downloadCount);
            } else {
              console.log(
                "Failed to load userProfile in teacher profile header",
                response
              );
            }
          });
          // setDownloadCount(userData.downloadCount); // Set the download count for teacher
        }
      } else {
        setIsAuthenticated(false); // Not authenticated
      }
    };

    checkAuth();
  }, []);

  const menuItems = [
    { label: "ANAVU", key: "/" },
    { label: "DOCUMENTATION" }, // No key, hence disabled
    { label: "TUTORIALS" },
    { label: "LICENSE", key: "/license" },
    { label: "ABOUT" }, // No key, hence disabled
  ];

  // Conditionally add "Dashboard" if authenticated, else "LOGIN/ACCOUNT"
  if (isAuthenticated) {
    // Map roles to dashboard routes
    const roleToDashboard = {
      Student: "/learner",
      Moderator: "/moderator/video-management",
      Teacher: downloadCount === false ? "/teacher/download" : "/teacher", // Check the download count for teachers
    };

    const dashboardRoute = roleToDashboard[userRole] || "/"; // Default to home if role not recognized
    menuItems.push({ label: "DASHBOARD", key: dashboardRoute });
  } else {
    menuItems.push({ label: "LOGIN/ACCOUNT", key: "/signin" });
  }

  const handleMenuClick = (key) => {
    if (key) {
      navigate(key); // Only navigate if key exists
    }
  };

  return (
    <nav className="landingPage_navbar">
      <div className="navbar-left">
        <img src={anavu_logo} alt="AnaVu Logo" className="navbar-logo" />
        <span className="navbar-title">AnaVu</span>
      </div>
      <div className="navbar-right">
        {menuItems.map((item) => (
          <span
            key={item.label}
            className={`navbar-link ${
              location.pathname === item.key ? "active" : "" // Add 'active' class if current path matches key
            } ${!item.key ? "disabled" : ""}`} // Apply disabled class if no key
            onClick={() => handleMenuClick(item.key)}
          >
            {item.label}
          </span>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
